import React from 'react';

import errorImg from "../../assets/img/errorimg.svg";

const ErrorPage = ({
    title = 'Щось пішло не так',
    message = 'Сталася непередбачена помилка. Ми вже отримали сповіщення про проблему.',
    details = null,
    homeLabel = 'На головну',
    homeHref = '/',
    showReload = true,
}) => {
    return (
        <div className="position-relative overflow-hidden min-vh-100 d-flex align-items-center justify-content-center p-4">
            <div className="row justify-content-center w-100">
                <div className="col-md-8 col-lg-6 col-xl-5">
                    <div className="text-center">
                        <img src={errorImg} alt="" className="img-fluid mb-4" width="420" />
                        <h1 className="fw-semibold mb-3 fs-8">{title}</h1>
                        <p className="text-muted mb-4">{message}</p>

                        {details && (
                            <div className="alert alert-light border text-start small mb-4" role="alert">
                                <div className="fw-semibold mb-1">Деталі помилки:</div>
                                <div className="text-muted text-break font-monospace">{details}</div>
                            </div>
                        )}

                        <div className="d-flex flex-wrap gap-2 justify-content-center">
                            <a className="btn btn-primary" href={homeHref} role="button">
                                {homeLabel}
                            </a>
                            {showReload && (
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary"
                                    onClick={() => {
                                        if (typeof window !== 'undefined') {
                                            window.location.reload();
                                        }
                                    }}
                                >
                                    Перезавантажити сторінку
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ErrorPage;
